<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars">
        <v-card-text>
          <div style="clear: both"></div>
          <template>
<!--            @click:row="showSingleTransaction"-->
            <v-data-table
              :headers="headers"
              :items="getAllETransactions"
              :items-per-page="10"
              single-select
              item-key="name"
              style="cursor: pointer"
            >
              <template v-slot:item.transactionType="{ item }">
                <v-chip
                  :color="getColor(item.transactionType)"
                  dark
                  outlined
                  label
                  style="width: 125px; cursor: pointer"
                >
                  <v-icon left size="16">{{
                    getIcon(item.transactionType)
                  }}</v-icon>
                  {{ item.transactionType }}
                </v-chip>
              </template>
              <template v-slot:item.transactionAmount="{ item }">
                <span :style="getColorMount(item.transactionAmount)">
                  {{
                    new Intl.NumberFormat("de-DE").format(
                      item.transactionAmount
                    )
                  }}
                  Akz
                </span>
              </template>

              <template v-slot:item.dateTransaction="{ item }">
                <span :style="getColorMount(item.dateTransaction)">
                  {{ formatData(item.dateTransaction) }}
                </span>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
    <open-modal-transaction></open-modal-transaction>
  </div>
</template>

<script>
import { mapHelperEnterprise } from "@/store/helperEnterprise";

import OpenModalTransaction from "@/components/dashboard/enterprise/tools/OpenModalTransaction";

export default {
  name: "History",
  components: { OpenModalTransaction },
  data: () => ({
    paginat: false,
    footeHiden: false,
    headers: [
      {
        text: "REFERÊNCIA",
        align: "start",
        sortable: false,
        value: "transactionDescription"
      },
      { text: "TIPO", value: "transactionType" },
      { text: "MONTANTE", value: "transactionAmount" },
      { text: "PRODUTO", value: "productName" },
      { text: "DATA", value: "dateTransaction" }
    ]
  }),
  methods: {
    getColor(type) {
      if (type === "Entrada") return "green";
      else if (type === "Saída") return "red";
      else return "orange";
    },
    getIcon(type) {
      if (type === "Entrada") return "mdi-arrow-up";
      else if (type === "Saída") return "mdi-arrow-down";
      else return "mdi-swap-horizontal";
    },
    getColorMount() {
      return "color:#1976d2c4";
    },
    formatData(convertData) {
      let format = new Date(convertData);
      return format.toISOString().split("T")[0];
    },
    // showSingleTransaction(item) {
    //   if (item) {
    //     this.drawer = !this.drawer;
    //     const payload = {
    //       dialog: true,
    //       drawer: true
    //     };
    //     eventBus.$emit("openModalTransaction", payload);
    //   }
    // }

    // getColor(type) {
    //   if (type === "Entrada") return "green";
    //   else if (type === "Saída") return "red";
    //   else return "orange";
    // },
    // getIcon(type) {
    //   if (type === "Entrada") return "mdi-arrow-up";
    //   else if (type === "Saída") return "mdi-arrow-down";
    //   else return "mdi-swap-horizontal";
    // },
    // getColorMount() {
    //   return "color:#1976d2c4";
    // }
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
